import { render, staticRenderFns } from "./csiApp.vue?vue&type=template&id=2a4c70aa&scoped=true&"
var script = {}
import style0 from "./csiApp.vue?vue&type=style&index=0&id=2a4c70aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c70aa",
  null
  
)

export default component.exports